import script from "./singleCall.vue?vue&type=script&setup=true&lang=js"
export * from "./singleCall.vue?vue&type=script&setup=true&lang=js"

import "./singleCall.vue?vue&type=style&index=0&id=245d15fe&lang=scss&scoped=true"

import exportComponent from "/Users/mac/projects/outproject/buge_project/xchatbuge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-245d15fe"]])

export default __exports__